// Re-export the useAnalytics hook from PostHog (primary analytics)
export { useAnalytics } from "./provider/posthog";

// Composite AnalyticsScript that loads both PostHog and Google Analytics
export { AnalyticsScript } from "./AnalyticsScript";

// Go-to-market conversions: PostHog and the LinkedIn Insight Tag in one call
export { trackConversion, trackConversionOnce } from "./conversions";
